import { Box, ToggleButton, ToggleButtonGroup, Typography } from "@mui/material";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import Chart from "react-apexcharts";
import { useDispatch, useSelector } from "react-redux";
// import { fetchStockDashboardData } from "../../../redux/slices/stockDashboardSlice";

const StockDashboard = () => {
  const dispatch = useDispatch();
  const { stockLevel, fastMovingProductName, loading, fastSlowMovers } = useSelector((state) => state.stockDashboard);
  const [selectedYear, setSelectedYear] = useState("2025");
  const [stockLevelData, setStockLevelData] = useState([]);
  const [fastMovingData, setFastMovingData] = useState([]);
  const [slowMovingData, setSlowMovingData] = useState([]);
  const [fastMovingView, setFastMovingView] = useState("Week");
  const [slowMovingView, setSlowMovingView] = useState("Week");

  useEffect(() => {
    if (!fastSlowMovers || (!fastSlowMovers?.fastMovers?.length && !fastSlowMovers?.slowMovers?.length)) return;
    setFastMovingData(fastSlowMovers?.fastMovers);
    setSlowMovingData(fastSlowMovers?.slowMovers);
  }, [fastSlowMovers])


  // useEffect(() => {
  //   dispatch(fetchStockDashboardData());
  // }, [dispatch]);

  // useEffect(() => {
  //   if (!stockLevel || !Array.isArray(stockLevel)) return;

  //   // LEFT: Stock Level Data
  //   const validStock = stockLevel.filter((item) => item.category);
  //   setStockLevelData(validStock);

  //   // RIGHT: Fast Moving Product based on selected year
  //   const yearData = fastMovingProductName[selectedYear] || [];
  //   setFastMovingData(yearData);
  // }, [stockLevel, fastMovingProductName, selectedYear]);

  // Handler for year change
  const handleYearChange = (e) => {
    setSelectedYear(e.target.value);
  };

  // Chart Options - Vertical Bar Chart (Stock Level)
  const barChartOptions = {
    chart: { type: "bar", toolbar: { show: false } },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "40%",
        borderRadius: 4,
      },
    },
    dataLabels: { enabled: false },
    xaxis: {
      categories: stockLevelData.map((item) => item.category),
      labels: {
        style: { fontSize: '14px', colors: '#2C2C49' },
        rotate: 0,
      },
    },
    yaxis: {
      labels: {
        formatter: (val) => val.toLocaleString(),
      },
    },
    grid: { strokeDashArray: 4 },
    colors: ["#0047AB"],
  };

  const barChartSeries = [
    {
      name: "Stock",
      data: stockLevelData.map((item) => item.stockLevel),
    },
  ];

  // Tooltip formatter for Fast Movers
  const fastMoversTooltipFormatter = useCallback(({ series, seriesIndex, dataPointIndex, w }) => {
    const item = fastMovingData?.[dataPointIndex];
    if (!item) return '';

    const productName = item?.productName || 'Unknown';
    const category = item?.category || 'N/A';
    const unitsSold = Number(item?.unitsSold ?? 0)?.toLocaleString() || '0';
    const salesValue = Number(item?.salesValue ?? 0)?.toLocaleString() || '0';
    const unitChange = `${Number(item?.unitsChangePercent ?? 0)?.toLocaleString() || '0'}%`;
    const previousUnitsSold = Number(item?.previousUnitsSold ?? 0)?.toLocaleString() || '0';
    const prevSalesValue = Number(item?.previousSalesValue ?? 0)?.toLocaleString() || '0';
    const color = w?.globals?.colors?.[seriesIndex] || '#0047AB';

    return (
      '<div class="apexcharts-tooltip-title" style="font-family: Helvetica, Arial, sans-serif; font-size: 12px; background-color: #EBEBEB; color: #000; padding: 8px; margin: 0;">' +
      productName +
      '<span class="apexcharts-tooltip-marker" style="background-color: ' +
      color +
      '; margin-left: 5px; width: 12px; height: 12px; border-radius: 2px; display: inline-block;"></span>' +
      "</div>" +
      '<div class="apexcharts-tooltip-series-group" style="order: 1; display: flex; background-color: #fff; padding: 8px;">' +
      '<div class="apexcharts-tooltip-text" style="font-family: Helvetica, Arial, sans-serif; font-size: 12px; color: #000;">' +
      '<div class="apexcharts-tooltip-y-group">' +
      '<span class="apexcharts-tooltip-text-y-label">Category: </span>' +
      '<span class="apexcharts-tooltip-text-y-value" style="font-weight: 600;">' +
      category +
      "</span>" +
      "</div>" +
      '<div class="apexcharts-tooltip-y-group">' +
      '<span class="apexcharts-tooltip-text-y-label">Unit Sold: </span>' +
      '<span class="apexcharts-tooltip-text-y-value" style="font-weight: 600;">' +
      unitsSold +
      "</span>" +
      "</div>" +
      '<div class="apexcharts-tooltip-y-group">' +
      '<span class="apexcharts-tooltip-text-y-label">Sales Value: </span>' +
      '<span class="apexcharts-tooltip-text-y-value" style="font-weight: 600;">' +
      salesValue +
      "</span>" +
      "</div>" +
      '<div class="apexcharts-tooltip-y-group">' +
      '<span class="apexcharts-tooltip-text-y-label">Unit Change: </span>' +
      '<span class="apexcharts-tooltip-text-y-value" style="font-weight: 600;">' +
      unitChange +
      "</span>" +
      "</div>" +
      '<div class="apexcharts-tooltip-y-group">' +
      '<span class="apexcharts-tooltip-text-y-label">Previous Units Sold: </span>' +
      '<span class="apexcharts-tooltip-text-y-value" style="font-weight: 600;">' +
      previousUnitsSold +
      "</span>" +
      "</div>" +
      '<div class="apexcharts-tooltip-y-group">' +
      '<span class="apexcharts-tooltip-text-y-label">Previous Sales Value: </span>' +
      '<span class="apexcharts-tooltip-text-y-value" style="font-weight: 600;">' +
      prevSalesValue +
      "</span>" +
      "</div>" +
      "</div>" +
      "</div>"
    );
  }, [fastMovingData]);

  // Chart Options - Horizontal Bar Chart (Fast Moving)
  const horizontalChartOptions = useMemo(() => ({
    chart: { type: "bar", toolbar: { show: false } },
    plotOptions: {
      bar: {
        horizontal: true,
        barHeight: '20%',
        borderRadius: 4,
      },
    },
    dataLabels: { enabled: false },
    xaxis: {
      categories: fastMovingData?.map((item) => item?.productName ?? ''),
      labels: {
        style: { fontSize: '12px', colors: '#2C2C49' }
      },
    },
    grid: { show: false },
    colors: ["#0047AB", "#E1D9FF", "#B829F4", "#DCE3F2", "#00C49F"],
    tooltip: {
      custom: fastMoversTooltipFormatter,
    },
  }), [fastMovingData, fastMoversTooltipFormatter]);

  const horizontalChartSeries = useMemo(() => [
    {
      data: fastMovingData?.map((item) => item?.unitsSold ?? 0),
    },
  ], [fastMovingData]);

  // Tooltip formatter for Slow Movers
  const slowMoversTooltipFormatter = useCallback(({ series, seriesIndex, dataPointIndex, w }) => {
    const item = slowMovingData?.[dataPointIndex];
    if (!item) return '';

    const productName = item?.productName || 'Unknown';
    const category = item?.category || 'N/A';
    const unitsSold = Number(item?.unitsSold ?? 0)?.toLocaleString() || '0';
    const salesValue = Number(item?.salesValue ?? 0)?.toLocaleString() || '0';
    const color = w?.globals?.colors?.[seriesIndex] || '#0047AB';
    const subUnits = Number(item?.subUnits ?? 0)?.toLocaleString() || '0';

    return (
      '<div class="apexcharts-tooltip-title" style="font-family: Helvetica, Arial, sans-serif; font-size: 12px; background-color: #EBEBEB; color: #000; padding: 8px; margin: 0;">' +
      productName +
      '<span class="apexcharts-tooltip-marker" style="background-color: ' +
      color +
      '; margin-left: 5px; width: 12px; height: 12px; border-radius: 2px; display: inline-block;"></span>' +
      "</div>" +
      '<div class="apexcharts-tooltip-series-group" style="order: 1; display: flex; background-color: #fff; padding: 8px;">' +
      '<div class="apexcharts-tooltip-text" style="font-family: Helvetica, Arial, sans-serif; font-size: 12px; color: #000;">' +
      '<div class="apexcharts-tooltip-y-group">' +
      '<span class="apexcharts-tooltip-text-y-label">Category: </span>' +
      '<span class="apexcharts-tooltip-text-y-value" style="font-weight: 600;">' +
      category +
      "</span>" +
      "</div>" +
      '<div class="apexcharts-tooltip-y-group">' +
      '<span class="apexcharts-tooltip-text-y-label">Unit Sold: </span>' +
      '<span class="apexcharts-tooltip-text-y-value" style="font-weight: 600;">' +
      unitsSold +
      "</span>" +
      "</div>" +
      '<div class="apexcharts-tooltip-y-group">' +
      '<span class="apexcharts-tooltip-text-y-label">Sales Value: </span>' +
      '<span class="apexcharts-tooltip-text-y-value" style="font-weight: 600;">' +
      salesValue +
      "</span>" +
      "</div>" +
      '<div class="apexcharts-tooltip-y-group">' +
      '<span class="apexcharts-tooltip-text-y-label">Sub units: </span>' +
      '<span class="apexcharts-tooltip-text-y-value" style="font-weight: 600;">' +
      subUnits +
      "</span>" +
      "</div>" +
      "</div>" +
      "</div>"
    );
  }, [slowMovingData]);

  const slowMovingChartOptions = useMemo(() => ({
    chart: { type: "bar", toolbar: { show: false } },
    plotOptions: {
      bar: {
        horizontal: true,
        barHeight: '20%',
        borderRadius: 4,
      },
    },
    dataLabels: { enabled: false },
    xaxis: {
      categories: slowMovingData?.map((item) => item?.productName ?? ''),
      labels: {
        style: { fontSize: '12px', colors: '#2C2C49' }
      },
    },
    grid: { show: false },
    colors: ["#0047AB", "#E1D9FF", "#B829F4", "#DCE3F2", "#00C49F"],
    tooltip: {
      custom: slowMoversTooltipFormatter,
    },
  }), [slowMovingData, slowMoversTooltipFormatter]);

  const slowMovingChartSeries = useMemo(() => [
    {
      data: slowMovingData?.map((item) => item?.unitsSold ?? 0),
    },
  ], [slowMovingData]);

  if (loading && !stockLevelData.length && !fastMovingData.length) {
    return <Box p={3}>Loading charts...</Box>;
  }

  return (
    <Box display="flex" gap={4} p={3} sx={{ flexWrap: 'nowrap', alignItems: 'flex-start' }}>
      {/* Stock Level Chart - Left */}
      {/* <Box
        sx={{
          backgroundColor: "#fff",
          borderRadius: 2,
          boxShadow: 2,
          padding: 3,
          flex: '1 1 60%',
          minWidth: 500,
        }}
      >
        <Box display="flex" justifyContent="space-between" mb={2}>
          <Typography variant="subtitle1" fontWeight={600}>
            Stock Level
          </Typography>
        </Box>
        <Chart options={barChartOptions} series={barChartSeries} type="bar" height={300} />
      </Box> */}

      {/* Fast Moving Product Chart - Right */}
      <Box
        sx={{
          backgroundColor: "#fff",
          borderRadius: 2,
          boxShadow: 2,
          padding: 3,
          flex: '1 1 40%',
          minWidth: 400,
        }}
      >
        <Box display="flex" justifyContent="space-between" mb={2}>
          <Typography variant="subtitle1" fontWeight={600}>
            Fast Movers
          </Typography>
          <ToggleButtonGroup
            value={fastMovingView}
            exclusive
            onChange={(_, val) => val && setFastMovingView(val)}
            size="small"
            sx={{
              backgroundColor: "#f0f2f5",
              borderRadius: "12px",
              "& .MuiToggleButtonGroup-grouped": {
                borderRadius: "7px",
                borderColor: "transparent",
                color: "#333",
                transition: "none",
                "&.Mui-selected": {
                  backgroundColor: "#005EB8",
                  color: "#fff",
                },
              },
            }}
          >
            <ToggleButton value="Week">Week</ToggleButton>
            <ToggleButton value="Month">Month</ToggleButton>
            <ToggleButton value="Quarter">Quarter</ToggleButton>
            <ToggleButton value="Year">Year</ToggleButton>
          </ToggleButtonGroup>
          {/* <Select
            value={selectedYear}
            onChange={handleYearChange}
            size="small"
            variant="outlined"
          >
            {["2024", "2025"].map((year) => (
              <MenuItem key={year} value={year}>
                {year}
              </MenuItem>
            ))}
          </Select> */}
        </Box>
        <Chart
          options={horizontalChartOptions}
          series={horizontalChartSeries}
          type="bar"
          height={280}
        />
      </Box>

      <Box
        sx={{
          backgroundColor: "#fff",
          borderRadius: 2,
          boxShadow: 2,
          padding: 3,
          flex: '1 1 40%',
          minWidth: 400,
        }}
      >
        <Box display="flex" justifyContent="space-between" mb={2}>
          <Typography variant="subtitle1" fontWeight={600}>
            Slow Movers
          </Typography>
          <ToggleButtonGroup
            value={slowMovingView}
            exclusive
            onChange={(_, val) => val && setSlowMovingView(val)}
            size="small"
            sx={{
              backgroundColor: "#f0f2f5",
              borderRadius: "12px",
              "& .MuiToggleButtonGroup-grouped": {
                borderRadius: "7px",
                borderColor: "transparent",
                color: "#333",
                transition: "none",
                "&.Mui-selected": {
                  backgroundColor: "#005EB8",
                  color: "#fff",
                },
              },
            }}
          >
            <ToggleButton value="Week">Week</ToggleButton>
            <ToggleButton value="Month">Month</ToggleButton>
            <ToggleButton value="Quarter">Quarter</ToggleButton>
            <ToggleButton value="Year">Year</ToggleButton>
          </ToggleButtonGroup>
          {/* <Select
            value={selectedYear}
            onChange={handleYearChange}
            size="small"
            variant="outlined"
          >
            {["2024", "2025"].map((year) => (
              <MenuItem key={year} value={year}>
                {year}
              </MenuItem>
            ))}
          </Select> */}
        </Box>
        <Chart
          options={slowMovingChartOptions}
          series={slowMovingChartSeries}
          type="bar"
          height={280}
        />
      </Box>
    </Box>
  );
};

export default StockDashboard;